module.exports = __webpack_public_path__ + "media/images/flags/64/Mali-d0d8a5e28f67445cef481691edba4cf8.png";